'use client';

import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

import { Goods } from './Goods';

interface GoodsImage {
  url: string;
  alt: string;
}
export interface GoodsItem {
  title: string;
  description: string;
  badgeText: string;
  goodsText: string;
  images: GoodsImage[];
}

interface GoodsSectionProps {
  items: [GoodsItem, GoodsItem];
}

const CONTAINER_ANIMATION = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.25,
      delayChildren: 0.2,
    },
  },
};

export const GoodsSection = ({ items }: GoodsSectionProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <ul className="flex w-full flex-col gap-60 bg-Gray-900 px-32 py-80">
      <motion.div
        ref={ref}
        variants={CONTAINER_ANIMATION}
        initial="hidden"
        animate={isInView ? 'visible' : 'hidden'}
        className="flex flex-col gap-60"
      >
        {items.map((item, index) => (
          <Goods
            key={index}
            title={item.title}
            description={item.description}
            badgeText={item.badgeText}
            goodsText={item.goodsText}
            images={item.images}
          />
        ))}
      </motion.div>
    </ul>
  );
};
